export function formatCellValue(value: any): string {
    if (value === null || value === undefined) {
        return '';
    }

    if (value && typeof value === 'object') {
        if (value.component === 'text' || value.component === 'copyText') {
            return value.config.text ?? '';
        }

        return JSON.stringify(value);
    }

    return String(value);
}
